import React from "react";

export const clockwise = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.335 25.1706C14.0594 25.1903 13.7808 25.2 13.5 25.2C7.04839 25.2 1.8 19.9516 1.8 13.5C1.8 7.04839 7.04839 1.8 13.5 1.8C17.4955 1.8 21.2168 3.88125 23.3508 7.2H20.7C20.2025 7.2 19.8 7.60298 19.8 8.1C19.8 8.59702 20.2025 9 20.7 9H25.2C25.6975 9 26.1 8.59702 26.1 8.1V3.6C26.1 3.10298 25.6975 2.7 25.2 2.7C24.7025 2.7 24.3 3.10298 24.3 3.6V5.41582C21.7767 2.06411 17.7741 0 13.5 0C6.0561 0 0 6.0561 0 13.5C0 20.9439 6.0561 27 13.5 27C13.8239 27 14.1447 26.9886 14.4624 26.9662C14.9581 26.931 15.3316 26.5003 15.2965 26.0046C15.2622 25.5089 14.8236 25.1464 14.335 25.1706Z"
        fill="currentColor"
      />
      <path
        d="M19.8229 23.3461C19.3562 23.6472 18.8631 23.9166 18.3604 24.1464C17.9077 24.3529 17.7091 24.8869 17.9157 25.3391C18.0668 25.67 18.3929 25.8655 18.7348 25.8655C18.8596 25.8655 18.987 25.8392 19.1074 25.7838C19.6893 25.5179 20.2588 25.2068 20.7985 24.8587C21.2159 24.5898 21.3364 24.0326 21.0674 23.6151C20.7976 23.1967 20.2412 23.0763 19.8229 23.3461Z"
        fill="currentColor"
      />
      <path
        d="M26.1002 12.6006C25.6027 12.6006 25.2002 13.0036 25.2002 13.5006C25.2002 14.0587 25.1606 14.6194 25.0824 15.167C25.0121 15.6592 25.3548 16.1149 25.847 16.1852C25.8901 16.1909 25.9323 16.194 25.9745 16.194C26.4157 16.194 26.8006 15.8701 26.8648 15.421C26.9545 14.7895 27.0002 14.1431 27.0002 13.5006C27.0002 13.0036 26.5976 12.6006 26.1002 12.6006Z"
        fill="currentColor"
      />
      <path
        d="M24.9927 18.7515C24.5568 18.5124 24.0092 18.6728 23.7711 19.1088C23.5048 19.5948 23.2007 20.0672 22.8667 20.5133C22.5678 20.911 22.6487 21.4752 23.0468 21.7732C23.2086 21.8945 23.3984 21.9529 23.5856 21.9529C23.8598 21.9529 24.1297 21.8286 24.3063 21.5926C24.6922 21.0784 25.0428 20.5335 25.3496 19.9727C25.5886 19.5368 25.4287 18.9901 24.9927 18.7515Z"
        fill="currentColor"
      />
      <path
        d="M12.6 4.50059V13.1279L7.46362 18.2643C7.11206 18.6158 7.11206 19.1854 7.46362 19.5369C7.6394 19.7127 7.86968 19.8006 8.09995 19.8006C8.33022 19.8006 8.5605 19.7127 8.73628 19.5369L14.1363 14.1369C14.305 13.9682 14.4 13.7392 14.4 13.5006V4.50059C14.4 4.00356 13.997 3.60059 13.5 3.60059C13.0029 3.60059 12.6 4.00356 12.6 4.50059Z"
        fill="currentColor"
      />
    </svg>
  );
};
